export function initJenisGardu() {
    // Edit logic
    $('.btn-edit-jenis').on('click', function() {
        const url = $(this).data('url-json');
        $('#modalJenisLabel').html('<i class="bi bi-pencil-square me-2"></i>Edit Jenis Gardu');
        
        $.get(url, function(response) {
            if (response.status === 'success') {
                const data = response.data;
                $('#id_jenis_gardu').val(data.id_jenis_gardu);
                $('#nama_jenis_gardu').val(data.nama_jenis_gardu);
                $('#keterangan').val(data.keterangan);
                $('#modalJenis').modal('show');
            }
        });
    });

    $('#btnCreateJenis').on('click', function() {
        $('#modalJenisLabel').html('<i class="bi bi-tags me-2"></i>Tambah Jenis Gardu');
        $('#formJenis')[0].reset();
        $('#id_jenis_gardu').val('');
    });

    $('#formJenis').on('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const btn = $('#btnSubmit');
        if (btn.prop('disabled')) return;
        
        btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Menyimpan...');
        
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: $(this).serialize(),
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil',
                        text: res.message,
                        showConfirmButton: false,
                        timer: 1500
                    }).then(() => location.reload());
                }
            },
            error: function(err) {
                btn.prop('disabled', false).html('<i class="bi bi-check-lg me-1"></i> Simpan');
                const res = err.responseJSON;
                const errorMsg = res?.errors?.nama_jenis_gardu || res?.message || 'Terjadi kesalahan sistem';
                Swal.fire('Error', errorMsg, 'error');
            }
        });
    });

    // NOTE: Delete is handled by global-crud.js via .btn-delete-submit

}
